import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaMinus } from 'react-icons/fa';

const KPICard = ({ 
  title, 
  value, 
  change, 
  changeType = 'neutral', 
  icon, 
  color = '#4DD5B8',
  subtitle,
  formatValue = (val) => val,
  loading = false
}) => {
  // Loading skeleton
  if (loading) {
    return (
      <div className="kpi-card" style={{
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        borderRadius: '16px',
        padding: '24px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e9ecef',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            background: '#e9ecef',
            animation: 'pulse 1.5s ease-in-out infinite'
          }} />
          <div style={{
            width: '60px',
            height: '20px',
            background: '#e9ecef',
            borderRadius: '4px',
            animation: 'pulse 1.5s ease-in-out infinite'
          }} />
        </div>
        <div style={{
          height: '40px',
          background: '#e9ecef',
          borderRadius: '8px',
          marginBottom: '12px',
          animation: 'pulse 1.5s ease-in-out infinite',
          width: '60%'
        }} />
        <div style={{
          height: '16px',
          background: '#e9ecef',
          borderRadius: '4px',
          marginBottom: '8px',
          animation: 'pulse 1.5s ease-in-out infinite',
          width: '80%'
        }} />
        <style>{`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}</style>
      </div>
    );
  }
  const getChangeIcon = () => {
    switch (changeType) {
      case 'positive':
        return <FaCheckCircle className="text-success" />;
      case 'negative':
        return <FaExclamationTriangle className="text-danger" />;
      default:
        return <FaMinus className="text-muted" />;
    }
  };

  const getChangeClass = () => {
    switch (changeType) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-danger';
      default:
        return 'text-muted';
    }
  };

  return (
    <div className="kpi-card" style={{
      background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
      borderRadius: '10px',
      padding: '12px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.06)',
      border: '1px solid #e9ecef',
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background accent */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '3px',
          background: `linear-gradient(90deg, ${color} 0%, ${color}80 100%)`,
        }}
      />
      
      <div className="d-flex justify-content-between align-items-start mb-2">
        <div className="kpi-icon" style={{
          width: '36px',
          height: '36px',
          borderRadius: '8px',
          background: `${color}15`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: color,
          fontSize: '16px'
        }}>
          {icon}
        </div>
        
        {change && (
          <div className="change-indicator d-flex align-items-center gap-1">
            {getChangeIcon()}
            <span className={`fw-semibold ${getChangeClass()}`} style={{ fontSize: '11px' }}>
              {change}
            </span>
          </div>
        )}
      </div>

      <div className="kpi-content">
        <h3 className="kpi-value mb-0" style={{
          fontSize: '22px',
          fontWeight: '700',
          color: '#151B22',
          margin: 0,
          lineHeight: '1.2'
        }}>
          {formatValue(value)}
        </h3>
        
        <p className="kpi-title mb-0 mt-1" style={{
          fontSize: '11px',
          color: '#6c757d',
          fontWeight: '500',
          margin: 0,
          textTransform: 'uppercase',
          letterSpacing: '0.3px'
        }}>
          {title}
        </p>
        
        {subtitle && (
          <p className="kpi-subtitle mt-0" style={{
            fontSize: '10px',
            color: '#6c757d',
            margin: 0,
            fontWeight: '400'
          }}>
            {subtitle}
          </p>
        )}
      </div>

      <style jsx>{`
        .kpi-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
        }
        
        .kpi-card:hover .kpi-icon {
          transform: scale(1.1);
        }
        
        .kpi-icon {
          transition: transform 0.3s ease;
        }
      `}</style>
    </div>
  );
};

export default KPICard;
